<style scoped>

</style>

<template>

  <v-container fluid>

    <v-layout wrap row>

      <v-flex xs12 md3 class="pa-1">

        <h3 v-if="loading">
          <v-progress-circular :size="20" indeterminate></v-progress-circular>
          Checking station status...
        </h3>

        <v-select class="hidden-md-and-up"
                  :items="stations"
                  v-model="currentStation"
                  item-value="STID"
                  item-text="NAME"
                  clearable
                  label="Pick Station"></v-select>

        <v-card class="hidden-sm-and-down pt-0" color="grey lighten-3">

          <v-list two-line="" dense class="pt-0">
            <v-subheader class="black white--text pt-0">Favorite Stations</v-subheader>
            <template v-for="st, index in stations">
              <v-divider></v-divider>
              <v-list-tile avatar
                           :key="index"
                           :to="{ name: $route.name, params: { id:st.STID } }"
                           :disabled="st.STATUS !== 'ACTIVE'"
                           active-class="grey lighten-3">
                <v-list-tile-avatar>
                  <v-icon color="green" right v-if="st.STATUS === 'ACTIVE'">thumb_up</v-icon>
                  <v-icon color="warning" right v-else>thumb_down</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>
                    <span class="right">{{st.ELEVATION}} ft.</span>
                    <span class="blue--text">{{st.STID}}</span>
                  </v-list-tile-title>
                  <v-list-tile-sub-title>{{st.NAME}}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>
          </v-list>

        </v-card>

      </v-flex>

      <v-flex xs12 md9 class="pa-1" d-flex>

        <v-card class="pa-3">

          <div>

            <h2 class="text-xs-center blue--text text--darken-3">{{currentName}}</h2>

            <v-tabs fixed-tabs
                    light
            >

              <v-tabs-slider color="primary"/>

              <v-tab :to="`/station/${$route.params.id}`" exact class="">
                <!--<v-icon class="pr-2">show_chart</v-icon>-->
                <v-icon class="pr-2">timeline</v-icon>
                Observations
              </v-tab>

              <v-tab :to="`/station/${$route.params.id}/overview`" exact class="">
                <v-icon class="pr-2">info</v-icon>
                Overview
              </v-tab>

            </v-tabs>

          </div>

          <router-view></router-view>

        </v-card>

      </v-flex>

    </v-layout>

  </v-container>

</template>

<script>
  import { find } from 'lodash';

  export default {

    name: 'StationIndex',

    data() {
      return {
        loading: false,
      };
    },

    computed: {

      stations() {
        return this.$store.state.station.stationList;
      },

      currentStation: {

        get() {
          if (this.$route.params.id) {
            return find(this.stations, { STID: this.$route.params.id }) || {};
          }
          return {};
        },

        set(station) {
          console.log(station);
          this.$router.push({
            ...this.$route,
            params: {
              id: station,
            },
          });
        },

      },

      currentName() {
        return this.currentStation.NAME;
      },

      currentStid() {
        return this.currentStation.STID;
      },

    },

    methods: {

      goRoute(stid) {
        this.$router.push({
          ...this.$route,
          params: {
            id: stid,
          },
        });
      },

    },

  };
</script>



// WEBPACK FOOTER //
// src/components/Station/Index.vue